import React from 'react'
import PropTypes from 'prop-types'

const NewsLetter = () => {
  return (
    <section className="px-6 py-10 lg:px-14 xl:px-[120px] lg:py-20 xl:py-[88px] pt-0 lg:pt-0 xl:pt-0 max-w-[1440px] m-auto">
      <div className="relative bg-[#F4633A] m-auto left-0 right-0 py-[88px] text-center">
        <IlustrationLeft className="absolute top-4 left-4 w-14 h-14 lg:top-6 lg:left-6 lg:w-[109px] lg:h-[109px]" />
        <IlustrationRight className="absolute bottom-4 right-4 w-14 h-14 lg:bottom-6 lg:right-6 lg:w-[109px] lg:h-[109px]" />

        <h1 className=" text-white text-[18px] md:text-[28px] font-bold leading-[150%] lg:w-[595px] m-auto left-0 right-0">
          Gabung dengan 1000+ mitra manuva se-Indonesia dengan 300+ SKUs produk
          pilihan
        </h1>

        <a
          href="#"
          className="inline-block mt-8 m-auto py-[18px] px-[40px] text-base font-medium rounded-xl border border-white text-white"
        >
          Get Started
        </a>
      </div>
    </section>
  )
}

const IlustrationLeft = ({ className }) => {
  return (
    <svg
      className={className}
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="76" height="76" fill="white" />
      <rect x="76" y="76" width="33" height="33" fill="#DEE9FF" />
    </svg>
  )
}

const IlustrationRight = ({ className }) => {
  return (
    <svg
      className={className}
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="33" y="33" width="76" height="76" fill="white" />
      <rect width="33" height="33" fill="#DEE9FF" />
    </svg>
  )
}

IlustrationLeft.propTypes = {
  className: PropTypes.string
}

IlustrationRight.propTypes = {
  className: PropTypes.string
}

export default NewsLetter
